/**
 * Role management service for admin interface
 * Feature: 001-user-role-management (Phase 5 - T089)
 * Security: Uses JWT-based authentication (no insecure query parameters)
 */
import { createApiClient } from '../lib/api';
import type { RoleWithPermissions } from '../types/role';

/**
 * List all roles with their permissions
 * Requires admin role (validated via JWT token)
 */
export async function listRoles(
  getToken: () => Promise<string | null>
): Promise<RoleWithPermissions[]> {
  const api = createApiClient(getToken);
  const response = await api.get<RoleWithPermissions[]>('/roles');
  return response.data;
}

/**
 * Get a single role by ID with full permission list
 * Requires admin role (validated via JWT token)
 */
export async function getRole(
  getToken: () => Promise<string | null>,
  roleId: string
): Promise<RoleWithPermissions> {
  const api = createApiClient(getToken);
  const response = await api.get<RoleWithPermissions>(`/roles/${roleId}`);
  return response.data;
}

export const roleService = {
  listRoles,
  getRole,
};
